<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- CADASTRO-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Cadastro de banner</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- INSTRUÇÕES -->
            <div class="col-sm-12">
              <div class="form-group">
                <span style="color: red">Instruções: Imagem 400x250 e Fundo branco ou transparente</span>
              </div>
            </div>

            <!-- ARQUIVO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputFile">Arquivo</label>
                <input class="form-control" type="file" @change="onChange" />

                <span style="color: red" v-for="error in v$.upload_files.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO -->
            <!--
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Leilão</label>

                <select class="custom-select rounded-0" v-model="formData.leilao_id" @change="searchLotes">
                  <option value=""></option>
                  <option v-for="leilao in leiloes" :key="leilao.id" :value="leilao.id">
                    {{ leilao.id + " - " + leilao.leilao_titulo }}
                  </option>
                </select>
              </div>
            </div>
            -->

            <!-- LEILÃO -->
            <div class="col-sm-6">
              <div class="form-group" id="form_group_comitente">
                <label for="comitente">Leilão ID</label>

                <div class="input-group mb-3">
                  <input class="form-control" id="nome" v-model="leilao_str" />
                  <span class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-primary"
                      id="confirmar"
                      @click="buscarLeiloes"
                      data-toggle="modal"
                      data-target="#leilao-modal"
                    >
                      Buscar
                    </button>
                  </span>
                </div>
                <!--
                <div class="input-group">
                  <v-container>
                    <v-autocomplete
                      v-model="query"
                      :items="results"
                      item-text="name"
                      item-value="id"
                      label="Digite para buscar"
                      :loading="isLoading"
                      :search-input.sync="query"
                      @update:search-input="onInput"
                      @input="onInput"
                      return-object
                    ></v-autocomplete>
                  </v-container>

                  <v-container>
                    <v-autocomplete
                      id="comitente"
                      variant="outlined"
                      :items="my_leiloes"
                      item-title="leilao_titulo"
                      return-object
                      v-model="formData.leilao_id"
                      density="compact"
                      style="text-transform: uppercase"
                      @update:search-input="onInput"
                    ></v-autocomplete>
                  </v-container>

                  <div class="input-group-append">
                    <button
                      style="max-height: 40px"
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#comitente-modal"
                      @click="cadastrarComitente"
                    >
                      <i class="fas fa-plus"></i>
                      Adicionar
                    </button>
                  </div>                  
                </div>
                -->
              </div>
            </div>

            <!-- LOTES -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Lotes</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.lote_id" @change="setUrlLote">
                  <option value=""></option>
                  <option v-for="lote in lotes" :key="lote.id" :value="lote.id">
                    {{ lote.lote_numero + " - " + lote.lote_titulo }}
                  </option>
                </select>
              </div>
            </div>

            <!-- URL -->
            <div class="col-sm-6" v-if="formData.leilao_id == ''">
              <div class="form-group">
                <label for="nome">Url</label>
                <input class="form-control" id="nome" placeholder="Url" v-model="formData.url" />

                <span v-if="formData.leilao_id == ''" style="color: red" v-for="error in v$.url.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- EXPIRA EM -->
            <div class="col-sm-6" v-if="formData.leilao_id == ''">
              <div class="form-group">
                <label for="nome">Expira em</label>

                <InputMask
                  id="basic"
                  class="form-control"
                  v-model="formData.expire_at"
                  placeholder="__/__/____  00:00"
                  mask="99/99/9999 99:99"
                  slotChar="__/__/____ 00:00"
                />

                <span v-if="formData.leilao_id == ''" style="color: red" v-for="error in v$.expire_at.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="sendFileS3()">Cadastrar</button>
          <a type="submit" href="/admin/banners" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="leilao-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Leilões</h4>
            <br />

            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th style="width: 10px">Id</th>
                    <th>Leilão</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(leilao, index) in leiloes" :key="leilao.id">
                    <td data-label="Seq">{{ leilao.id }}</td>
                    <td data-label="Seq">{{ leilao.leilao_titulo }}</td>

                    <td data-label="Ações">
                      <button style="margin-left: 15px" class="btn btn-primary btn-sm" @click="selecionarLeilao(leilao)" data-dismiss="modal">
                        Selecionar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer clearfix">
              <!-- TOTAIS  
              <div style="font-size: 13px" class="float-left" aria-live="polite">
                Exibindo do {{ inicio + 1 }} ao {{ inicio + users.length }}
                <p>Total {{ total }}</p>
              </div>
              -->

              <!-- PAGINAÇÃO
              <ul class="pagination pagination-sm m-0 float-right">
                <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
                <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

                <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                  <a
                    :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                    class="page-link"
                    href="#"
                    @click="selecionarPagina(pagina)"
                  >
                    {{ pagina }}
                  </a>
                </li>

                <li class="page-item">
                  <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
                </li>
                <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
              </ul>
                -->
            </div>
            <!-- /.card-body -->

            <button id="leilao-modal" style="margin-left: 15px" data-toggle="modal" data-target="#leilao-modal" class="btn btn-danger btn-sm">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import InputMask from "primevue/inputmask";

export default {
  mixins: [sweetAlert, Swal],

  props: ["leiloes"],

  components: { Loading, InputMask },

  data() {
    return {
      isLoading: false,
      results: [],
      lotes: [],
      my_leiloes: [],
      query: "",
      leiloes: "",
      leilao_str: "",
      leilao_selecionado: "",
    };
  },

  setup() {
    const formData = reactive({
      url: "",
      expire_at: "",
      upload_files: "",
      leilao_id: "",
      lote_id: "",
    });

    const rules = computed(() => {
      let local_rules = {
        upload_files: { required },
      };

      if (formData.leilao_id == "") {
        local_rules.expire_at = { required };
      }

      if (formData.leilao_id == "") {
        local_rules.url = { required };
      }

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log(this.leiloes);

    //this.buscarLeiloes();
  },

  methods: {
    async onInput() {
      console.log(this.query);

      this.$nextTick(function () {
        console.log("Busca atualizada:", this.query); // Acessa a variável após o DOM ser atualizado
      });

      if (this.query.length > 2) {
        this.isLoading = true;

        console.log(this.query);

        try {
          // Requisição à API para busca dos resultados
          const response = await axios.get("https://api.exemplo.com/search", {
            params: { query: this.query },
          });
          this.results = response.data; // Armazena os resultados no array
        } catch (error) {
          console.error("Erro na busca:", error);
        } finally {
          this.isLoading = false;
        }
      } else {
        this.results = []; // Limpa os resultados se a pesquisa for muito curta
      }
    },

    selecionarLeilao(leilao) {
      this.formData.leilao_id = leilao.id;
      this.leilao_selecionado = leilao;

      this.leilao_str = leilao.id;

      this.searchLotes();
    },

    change(event) {
      console.log("CHANGE");
      console.log(event);
    },

    buscarLeiloes() {
      let data = {
        inicio: 0,
        tamanho: 20,
        id: this.leilao_str,
        id_like: true,
      };

      console.log(data);

      axios
        .post(`/admin/leilao/search`, data)
        .then((response) => {
          this.leiloes = response.data.leiloes;
          this.my_leiloes = response.data.leiloes;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    onChange(e) {
      this.formData.upload_files = e.target.files[0];
    },

    searchLotes() {
      if (this.formData.leilao_id) {
        let data = {
          leilao_id: this.formData.leilao_id,
        };

        this.formData.lote_id = null;
        this.formData.expire_at = null;

        axios
          .post(`/admin/lote/find_by_leilao/`, data)
          .then((response) => {
            this.lotes = response.data.lotes;
            this.formData.url = null;

            this.setUrlLeilao();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      } else {
        this.formData.url = null;
      }
    },

    setUrlLeilao() {
      let indice = this.findLeilao(this.formData.leilao_id);

      if (indice >= 0) {
        this.formData.url = "/leilao/" + this.leiloes[indice].id + "/lotes";
      }
    },

    setUrlLote() {
      let indice = this.findLote(this.formData.lote_id);

      if (indice >= 0) {
        this.formData.url = "/lote/" + this.lotes[indice].id;
      }
    },

    findLeilao(id) {
      let indice = this.leiloes.findIndex((element) => element["id"] == id);

      return indice;
    },

    findLote(id) {
      let indice = this.lotes.findIndex((element) => element["id"] == id);

      return indice;
    },

    async sendFileS3() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("id", "1");
          formData.append("path", "rochaleiloes2/banners/");
          formData.append("file", this.formData.upload_files);

          axios
            .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
            .then((response) => {
              console.log("ENVIANDO PARA O BANCO\n");

              this.uploadFD(response.data.key);
            })
            .catch((error) => {
              console.log(error);

              this.isLoading = false;
              this.showErrorMessageWithButton("Ops..", error.response.data.error);
              console.log(error);
              reject();
            });
        });
      }
    },

    uploadFD(file) {
      this.isLoading = true;

      let fileName = file.split("/");

      let fd = new FormData();
      fd.append("file", fileName[fileName.length - 1]);
      fd.append("path", "rochaleiloes2/banners");
      fd.append("url", this.formData.url);
      fd.append("expires_at", this.formatSelectedDate3(this.formData.expire_at));

      if (this.formData.leilao_id) {
        fd.append("leilao_id", this.formData.leilao_id);
      }

      if (this.formData.lote_id) {
        fd.append("lote_id", this.formData.lote_id);
      }

      console.log("Cadastrando");
      console.log(this.formData.leilao_id);
      console.log(this.formData.lote_id);
      console.log(this.formData.expire_at);

      axios
        .post(`/admin/banner/store`, fd)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Banner cadastrado", "/admin/banners");
        })
        .catch((error) => {
          console.log(error);

          this.isLoading = false;

          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    //FORMATA A DATA PARA ENVIAR PARA O BANCO (De DD-MM-yyyy HH:mm:ss Para yyyy-MM-DD HH:mm:ss )
    formatSelectedDate3(date) {
      if (date) {
        return moment(date, "DD-MM-yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
